import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CustomIconButton } from "../icon-button";
export function ArrowDownIcon() {
  return (
    <CustomIconButton>
      <KeyboardArrowDownIcon />
    </CustomIconButton>
  );
}
